let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("iCBCg")).then(() => parcelRequire('4DbYK'));